<template>
  <div class="col-sm-12">
    <div class="card tranaction-card">
      <div class="card-header card-no-border">
        <div class="header-top">
          <h5>Complaints</h5>
          <ul class="nav nav-tabs custom-tab" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
              <button class="nav-link active text-danger" id="pending-tab" data-bs-toggle="tab" data-bs-target="#pending" type="button" role="tab" aria-controls="pending" aria-selected="true">
                Pending
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link text-primary" id="inprogress-tab" data-bs-toggle="tab" data-bs-target="#inprogress" type="button" role="tab" aria-controls="inprogress" aria-selected="false">
                Inprogress
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link text-success" id="completed-tab" data-bs-toggle="tab" data-bs-target="#completed" type="button" role="tab" aria-controls="completed" aria-selected="false">
                Completed
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div class="card-body pt-0">
        <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade show active" id="pending" role="tabpanel" aria-labelledby="pending-tab">
            <PendingTable />
          </div>
          <div class="tab-pane fade" id="inprogress" role="tabpanel" aria-labelledby="inprogress-tab">
            <InprogressTable />
          </div>
          <div class="tab-pane fade" id="completed" role="tabpanel" aria-labelledby="completed-tab">
            <CompleteTable />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PendingTable from '@/pages/dashboard/distributor/tables/ComplaintsComponent/PendingTable.vue'
import InprogressTable from "@/pages/dashboard/distributor/tables/ComplaintsComponent/InprogressTable.vue";
import CompleteTable from "@/pages/dashboard/distributor/tables/ComplaintsComponent/CompletedTable.vue"

export default {
  components: {
    PendingTable,
    InprogressTable,
    CompleteTable
  }
}
</script>
